import { ViewModel,View } from "binder"
import  { ProductHuntView } from "./productHunt-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { downloadFile } from "src/uicomponents/components/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ProductHuntViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گزارش هانت کالا';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ProductHuntView();
    }
    public getTypeId(): string {
        return "VM-5FFEDE10-27EB-4F77-ABBC-D4D08DBF7566"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;

    async download(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer("/Complex/ReportServices/ProductHuntReport", {
                FromDateTime : this.from,
                UntilDateTime : this.until
            });
            downloadFile(result.ExcelFile,'گزارش هانت کالا.xlsx');
            if(result.IsSuccessful == true){
                await this.messageBoxConfirmSuccess("گزارش با موفقیت دانلود شد.","گزارش هانت کالا");
            }

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
